module.exports = __webpack_public_path__ + "static/media/2019_mar_live_baccarat_environment_overview_4 1.a0a13ec1.png";